import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FormattedMessage } from 'react-intl';
import jQuery from 'jquery';
import ModalBox from '../ModalBox/ModalBox';
import Utility from '../Utility/Utility';
import { DlgContent } from './TranslateDlgs';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-bs5';
import './Translations.css';

const Translations = () => {
    const [show, showModal] = useState( false );
	const [modalSize, setModalSize] = useState( "xl" );
	const [modalTitle, setModalTitle] = useState( "" );
	//const [appDirs, setAppDirs] = useState( [] );

	const Utl 		= new Utility();
	const language 	= Utl.getCookie("appLang");
	//const appDirs   = JSON.parse(localStorage.getItem('appDirs'));                                          	//- Get current directory information
	//const adminDir  = appDirs["admin"];

    const handleModalExit = () => {                                                                             //- Handle modal dialog box
        showModal( false );                                                                                     //- Set modal dialog box show status
    };

    useEffect(() => {
		const appDirs 	= JSON.parse(localStorage.getItem('appDirs'));
		const adminDir 	= appDirs["admin"];
		let server 		= adminDir + "/api/appAgent.php"
		let Utl 		= new Utility();
		let language 	= Utl.getCookie("appLang");
		let table 		= "appTranslateTbl";

        const translateTable = jQuery( '#' + table ).DataTable({
            serverSide : true,
			processing : true,
            pageLength : 10,
			ajax : {
                url: server,
				type : 'POST',
                data: { "method": 13 },
				"error": function (xhr, error, thrown) {
					Utl.appLogger("AJAX Error: "); Utl.appLogger(xhr); Utl.appLogger(error); Utl.appLogger(thrown);
                }
			},
			columns : [
				{ title : 'Tag ID', data : 'lng_id', className : 'app-lang-tbl-col-id' },
				{ title : ( language === "en" ? 'Delete' : 'Borre' ), orderable: false, render : function ( data, type, row, meta ) { return("<i class='fa fa-trash fa-fw' aria-hidden='true' title='Delete'></i>"); }, className: 'app-lang-tbl-col-del text-center' },
                { title : ( language === "en" ? "Key Name" : "Nombre de Etiqueta" ), data : 'lng_name', className : 'app-lang-trans-col app-lang-tbl-col-name' },
				{ title : ( language === "en" ? "English" : "Inglés" ), data : 'lng_description', className : 'app-lang-trans-col app-lang-tbl-col-desc-en' },
				{ title : ( language === "en" ? 'Spanish' : "Español" ), data : 'tEs_lng_desc', className : 'app-lang-trans-col app-lang-tbl-col-desc-es' }
			],
			"language": { 
		    	"emptyTable": "<h2>No records found</h2>", 
		    	"info": ( language === "en" ? "Showing _START_ to _END_ of _TOTAL_ tags" : "Mostrando _START_ a _END_ de _TOTAL_ etiquetas" ),
				"search": "Search",
				"processing": document.getElementById( "appTransProcess" ).innerHTML
		    },
            "initComplete": function(settings, data) {
                Utl.appLogger("Translations data returned: ", data );

				if( document.getElementById("appAddIcon") === null ) {											//- Check if the add icon has already been added
					const addTitle = document.getElementById( "appTransAdd" ).innerHTML;
					jQuery( ".dt-length").append( "<a id='appAddIcon' class='text-dark text-decoration-none' href='javascript:void(0)'><div class='ms-4 d-inline app-add-key'><i class='fas fa-plus-circle me-2'></i>"+addTitle+"</div></a>" );
					jQuery( '<div class="d-inline"><i class="fas fa-file-alt"></i></div>' ).insertBefore( ".dt-length" );
					jQuery( ".dt-length" ).addClass( "d-inline" );
				}

				let lengthTimer = setInterval(function() {
					if( window.document.readyState === "complete" ) {
						document.getElementsByTagName("label")[0].innerHTML = document.getElementById( "appTransRecords" ).innerHTML;
						document.getElementsByTagName("label")[1].innerHTML = document.getElementById( "appTransSearch" ).innerHTML;
						document.getElementsByClassName("app-add-key")[0].innerHTML = 
						'<i class="fas fa-plus-circle me-2" aria-hidden="true"></i>' + document.getElementById( "appTransAdd" ).innerHTML;
						clearInterval(lengthTimer);
					}
				}, 100);

				//- Add tag
				jQuery( "#appAddIcon" ).on( "click tap", function( event ) {
					event.stopImmediatePropagation();
					Utl.appLogger( "Add event: ", event );

					setModalTitle( document.getElementById( "appTransAddKey" ).innerHTML );						//- Set dialog header title with current language
					showModal( true );

					let timerId = setInterval(function() {                                              		//- Set an interval timer and
						const appDiv = document.getElementById( "appModalBody" );                 				//- get the dialog body div
						if( appDiv !== null ) {
							jQuery( "#appModalBody" ).append(DlgContent);
							AddEditKey( null );
							clearInterval(timerId);                                                     		//- Clear the interval
						}
					}, 75);
				});

                //- Edit tag
				jQuery( '#' + table + ' tbody').on('click tap', 'td.app-lang-trans-col', function ( event ) {
					event.stopImmediatePropagation();
					Utl.appLogger( "Edit event: ", event );
					
					setModalSize("xl");
					setModalTitle( document.getElementById( "appTransEditKey" ).innerHTML );					//- Set dialog header title with current language
					showModal( true );
					
					const appTbl = jQuery( '#appTranslateTbl' ).DataTable();
				    const tr = jQuery(this).closest('tr');
				    const row = appTbl.row( tr );
					Utl.appLogger("editProgram row: ", row );

                    let timerId = setInterval(function() {                                              		//- Set an interval timer and
                        const appDiv = document.getElementById( "appModalBody" );                 				//- get the dialog body div
                        if( appDiv !== null ) {
							jQuery( "#appModalBody" ).append(DlgContent);
							AddEditKey( row );
							clearInterval(timerId);                                                     		//- Clear the interval
                        }
                    }, 75);
				});

				//- Delete tag
				jQuery( '#' + table + ' tbody').on('click tap', 'td.app-lang-tbl-col-del', function ( event ) {
					event.stopImmediatePropagation();
					Utl.appLogger( "Edit event: ", event );

					const appTbl = jQuery( '#appTranslateTbl' ).DataTable();
				    const tr = jQuery(this).closest('tr');
				    const row = appTbl.row( tr );
					Utl.appLogger("editProgram row: ", row );

					setModalSize("md");
					setModalTitle( document.getElementById( "appDeleteTitle" ).innerHTML + 
															" " + row.data().lng_name );						//- Set dialog header title with current language
					showModal( true );

					let timerId = setInterval(function() {                                              		//- Set an interval timer and
						const appDiv = document.getElementById( "appModalBody" );                 				//- get the dialog body div
                        if( appDiv !== null ) {
							const dlgQuestion = document.getElementById( "appTransDelQuest" ).innerHTML;

							jQuery( "#appModalBody" ).append( "<div class='text-center'>" +dlgQuestion+ "</div>" );
							document.getElementById("appSubmitBtn").innerHTML = document.getElementById( "appYesText" ).innerHTML;
							document.getElementById("appCloseBtn").innerHTML = "No";
							clearInterval(timerId);

							jQuery( "#appSubmitBtn" ).on( "click tap", function( event ) {
								event.stopImmediatePropagation();
								let langServer = adminDir + "/api/LanguageAgent.php";							//- Get server location depending on Dev/Production
					
								jQuery.ajax({
									url:langServer,
									type:'post',
									data: { "method":11, "lng_id":row.data().lng_id },
									dataType:'json',
									success: function( data ) {
										Utl.appLogger("Delete translations data: ", data );
										appTbl.draw( false );													//- This updates the current page ( not passing the parameter 'false' redraws the entire table and moves to page one)
										showModal( false );														//- Remove dialog box
									},
									error: function(  jqXHR, textStatus, errorThrown  ){
										let errMsg = 'Network failure: '+textStatus+" ("+errorThrown+")";
										Utl.appLogger( errMsg );
									},
									complete: function(){
										Utl.appLogger( 'Delete translations completed', "");
									}
								});
							});
						}
					}, 75);
				});
            }
        });

		const AddEditKey = ( row ) => {
			let langServer = adminDir + "/api/LanguageAgent.php";												//- Get server location depending on Dev/Production

			if( row !== null ) {
				jQuery( "#lng_id" ).val( row.data().lng_id );
				jQuery( "#lng_name" ).val( row.data().lng_name );
				jQuery( "#lng_description_en" ).val( row.data().lng_description );
				jQuery( "#lng_description_es" ).val( row.data().tEs_lng_desc );
			} else {
				jQuery( "#lng_id" ).val( "0" );
			}
	
			document.getElementById("lng_name").focus();
	
			jQuery( "#appSubmitBtn" ).on( "click tap", function( event ) {
				event.stopImmediatePropagation();
				let errMsg = "";
				const appTbl = jQuery( '#appTranslateTbl' ).DataTable();
				const lng_id = jQuery( "#lng_id" ).val();
				const lng_name = jQuery( "#lng_name" ).val();
				const lng_description_en = jQuery( "#lng_description_en" ).val();
				const lng_description_es = jQuery( "#lng_description_es" ).val();
	
				jQuery.ajax({
					url:langServer,
					type:'post',
					data: { "method":10, "lng_id":lng_id, "lng_name":lng_name, "lng_description_en":lng_description_en, "lng_description_es":lng_description_es },
					dataType:'json',
					success: function( data ) {
						Utl.appLogger("add/Update translations data: ", data );
						switch( data[0] ) {
							case 0:
							case 2:
								document.getElementById( "appModalMsgs" ).innerHTML = document.getElementById( "appKeyExistsText" ).innerHTML;
								document.getElementById("lng_name").focus();
								break;
							case 1:
								document.getElementById( "appModalMsgs" ).innerHTML = document.getElementById( "appErrorText" ).innerHTML + ": " + data[1];
								document.getElementById("lng_name").focus();
								break;
							default:
								appTbl.draw( false );															//- This updates the current page ( not passing the parameter 'false' redraws the entire table and moves to page one)
								showModal( false );																//- Remove dialog box
							break;
						}
					},
					error: function(  jqXHR, textStatus, errorThrown  ) {
						errMsg = 'Network failure: '+textStatus+" ("+errorThrown+")";
						Utl.appLogger( errMsg );
					},
					complete: function(){
						Utl.appLogger( 'Add/Update translations completed', "");
					}
				});
			});
		};

        return () => {
			translateTable.destroy();
		};

    }, []);

    return (
        <>
		<div id="appTransRecords" className='d-none'><FormattedMessage id = "app-trans-records" defaultMessage="Records" /></div>
		<div id="appTransProcess" className='d-none'><FormattedMessage id = "app-trans-process" defaultMessage="Process" /></div>
		<div id="appTransSearch" className='d-none'><FormattedMessage id = "app-trans-search" defaultMessage="Search" /></div>
		<div id="appTransAdd" className='d-none'><FormattedMessage id = "app-trans-add" defaultMessage="Add" /></div>
		<div id="appTransAddKey" className='d-none'><FormattedMessage id = "app-trans-add-key" defaultMessage="Add Key" /></div>
		<div id="appTransEditKey" className='d-none'><FormattedMessage id = "app-trans-edit-key" defaultMessage="Edit Key" /></div>
		<div id="appTransDelQuest" className='d-none'><FormattedMessage id = "app-trans-del-question" defaultMessage="Delete Key" /></div>

		<div className="container-fluid">
			<h1 className="mt-5 mb-5 text-center">
				<b>
					<FormattedMessage
                        id = "app-dash-translations"
                        defaultMessage="Translations"
                    />
				</b>
			</h1>
			<div className="card">
				<div className="card-header">
					<FormattedMessage
                        id = "app-language-translations"
                        defaultMessage="Language Translations"
                    />
				</div>
				<div className="card-body">
					<table className="table table-bordered table-striped display table-hover" id="appTranslateTbl">
						<thead>
							<tr>
							</tr>
						</thead>
						<tbody></tbody>
					</table>
				</div>
			</div>
		</div>
        {show &&
           createPortal( <ModalBox show={true} onExit={handleModalExit} title={modalTitle} submit={true} size={modalSize} closeBtn={language === 'es' ? "Cierre" : "Close"} submitBtn={language === 'es' ? "Actualizar" : "Submit"} />, document.body ) 
        }
        </>
	);
}

export default Translations;